import Vue from 'vue';
import moment from 'moment';
import filterCondition from '../../../components/console-common/first-filter-condition.vue';
import fundTable from '../../../components/fund/table.vue';
import agreementDataCredit from '../../../components/console-common/agreement-data-credit.vue';
export default Vue.extend({
    name: 'dataCreditList',
    components: {
        'fileter-condition': filterCondition,
        'fund-table': fundTable,
        'agreement-data-credit': agreementDataCredit,
    },
    data: function () {
        var _this = this;
        return {
            dialogVisible: false,
            capitalName: '',
            currentData: {},
            queryConditionConfig: [
                {
                    type: 'normal',
                    label: 'cp名称',
                    key: 'tenantName',
                    placeholder: '请输入cp名称',
                },
            ],
            tableRequestConfig: {
                url: '/proxy/fund-api/capital/getLicenseAgreement',
                method: 'post',
                inputParam: {
                    tenantName: '',
                    registerProvinceCity: '',
                },
            },
            tableDataConfig: [
                {
                    label: 'cp名称',
                    prop: 'tenantName',
                },
                {
                    label: 'cp城市',
                    prop: 'registerProvinceCity',
                    formatter: function (current) {
                        return current || '--';
                    },
                },
                {
                    label: '授权状态',
                    prop: 'signStatus',
                    formatter: function (current) {
                        var status = {
                            NON_SIGN: '待签署',
                            AGREE: '已签署',
                            REFUSE: '已拒绝',
                        };
                        return status[current] || '--';
                    },
                },
                {
                    label: '发送时间',
                    prop: 'sendTime',
                    width: '220px',
                    formatter: function (sendTime) {
                        return sendTime
                            ? moment(sendTime).format('YYYY-MM-DD HH:mm:ss')
                            : '';
                    },
                },
                {
                    label: '授权时间',
                    prop: 'signTime',
                    width: '220px',
                    formatter: function (current, row) {
                        var signStatus = row.signStatus;
                        return signStatus === 'AGREE' && current
                            ? moment(current).format('YYYY-MM-DD HH:mm:ss')
                            : '--';
                    },
                },
                {
                    label: '授权文件',
                    prop: 'ope_control_group',
                    btns: [
                        {
                            name: '查看',
                            formatter: function () {
                                return true;
                            },
                            border: function () {
                                return false;
                            },
                            callback: function (row) {
                                var capitalName = row.capitalName;
                                _this.currentData = row;
                                _this.capitalName = capitalName;
                                _this.dialogVisible = true;
                            },
                        },
                        {
                            name: '下载',
                            formatter: function (row) {
                                var signStatus = row.signStatus;
                                return signStatus === 'AGREE';
                            },
                            border: function (row) {
                                var btn = _this.tableDataConfig[_this.tableDataConfig.length - 1].btns;
                                return btn[0].formatter(row) || btn[1].formatter(row);
                            },
                            callback: function (row) {
                                var licenseFile = row.licenseFile;
                                if (licenseFile) {
                                    return window.open(licenseFile);
                                }
                                _this.$message.error('暂无下载链接');
                            },
                        },
                    ],
                },
            ],
        };
    },
    methods: {
        getQueryConditon: function (params) {
            this.tableRequestConfig.inputParam = Object.assign({}, params);
        },
    },
});
